import React from "react";

// TODO - postupne sem prenest vsechny parametry ktere se debilne predavaji pres props

const defaults: {
  submission?: any,
  formSchemaVersion?: string
} = {}
const SuperContext = React.createContext(defaults);

export default SuperContext;
